import { useLayoutEffect, useState } from "react";

export default function useTableSize({
  headerDimensions,
}: {
  headerDimensions: {
    width: number;
    height: number;
  }[];
}) {
  const viewPortSize = useViewportSize();

  const headerRefsHeightSum = headerDimensions.reduce((acc, ref) => {
    if (ref) {
      return acc + ref.height;
    }
    return acc + 20;
  }, 0);
  const tableSize = viewPortSize.height - 64 - headerRefsHeightSum - 30 - 120;

  return tableSize;
}

export function useViewportSize() {
  const [viewportSize, setViewportSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useLayoutEffect(() => {
    function handleResize() {
      setViewportSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return viewportSize;
}
